<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        icon
        :color="isEditMode? 'red':''"
        :outlined="isEditMode"
        small
        v-on="on"
        v-bind="attrs"
        class="ml-1"
        >
          <v-icon>mode_edit</v-icon>
          <!-- {{isEditMode? 'Leave':'Enter'}} Edit Mode -->
        </v-btn>
      </template>
      <span>{{isEditMode? $t('AppLayout.NavBar.Project.TaktPlan.Leave'):$t('AppLayout.NavBar.Project.TaktPlan.Enter')}} {{$t('AppLayout.NavBar.Project.TaktPlan.EditMode')}}</span>
    </v-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['isEditMode']
  }
</script>
